export * from '@fhs/routing/src/routes/(auth)/signup';
export { default } from '@fhs/routing/src/routes/(auth)/signup';
